export { createVAComponentProps } from './component-props';
